import { render, staticRenderFns } from "./JumpingErrorComponent.vue?vue&type=template&id=26d4c28e&scoped=true"
import script from "./JumpingErrorComponent.vue?vue&type=script&lang=ts"
export * from "./JumpingErrorComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d4c28e",
  null
  
)

export default component.exports